import { Component, Input, OnInit } from '@angular/core';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'lifedi-card-box',
  templateUrl: './card-box.component.html',
  styleUrls: ['./card-box.component.scss']
})
export class CardBoxComponent implements OnInit {
  @Input() id: string;
  @Input() date: Date;
  @Input() title: string;
  @Input() content: string;
  @Input() imageUrl: string;
  @Input() teacherName: string;
  @Input() price: number;

  clearContent: string;

  constructor(
    private gobalFunctionService: GobalFunctionService
  ) {
  }

  ngOnInit(): void {
    if (this.content) {
      this.clearContent = this.gobalFunctionService.clearTag(this.content);
    }
  }

}
